
    import _debounce from 'lodash/debounce';

    export default {
        components: {
        },
        data() {
            return {
                visible: false,
                searchQuery: '',
                blogs: [],
                loading: false,
                page: 1, // Pagination
                hasMore: true, // Track if more blogs are available
            };
        },
        created() {
            // Assign debounced function in created hook
            this.debouncedSearch = _debounce(() => this.fetchBlogs(true), 200);
        },
        methods: {
            showModal() {
                this.visible = true;
            },
            closeModal() {
                this.visible = false;
                this.searchQuery = '';
                this.blogs = [];
                this.page = 1;
                this.hasMore = true;
            },
            goToBlog(slug) {
                this.closeModal(); // Close the modal
                this.$router.push(`${slug}`); // Navigate to the blog page
            },
            async fetchBlogs(reset = false) {
                if (!this.searchQuery.trim()) return;
                this.loading = true;
                if (reset) {
                    this.page = 1;
                    this.hasMore = true;
                    this.blogs = [];
                }

                try {
                    const { data: { data: { pages } } } = await this.$axios.get(`/u/pages?searchKey=${this.searchQuery}&origin=benhvien16a.com&page=${this.page}`);

                    if (pages.length === 0) {
                        this.hasMore = false;
                    } else {
                        if (reset) {
                            this.blogs = pages;
                        } else {
                            this.blogs = [...this.blogs, ...pages];
                        }
                        // eslint-disable-next-line no-plusplus
                        this.page++;
                    }
                } catch (error) {
                    console.error('Error fetching blogs:', error);
                } finally {
                    this.loading = false;
                }
            },
            handleScroll() {
                const container = this.$refs.scrollContainer;
                if (container && this.hasMore && !this.loading) {
                    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 20) {
                        this.fetchBlogs(false);
                    }
                }
            },
        },
    };
  